import { getServiceName, Lookup, PropertyTypesItems, SubscriptionService, SubscriptionServiceId } from "@eres/greenlistapi/entities";
import Strings from "@my-dld/assets/strings";
import React, { Component } from "react";
import { handleDataUpdate, IGreenListForm, IGreenListFormProps, IGreenListFormState } from "./Base";
import { getGreenListAres } from "@eres/greenlistapi/Utils";
import { CurrencyUtil, LocaleUtil } from "@eres/core";
import MultiChoiceDropDown from "../../DropDown/MultiChoiceDropDown";
import { Props as BDProps } from "../../DropDown/BaseDropDown";
import { SpinnerLoader } from "../../SpinnerLoader";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import CurrencyInput from "@my-dld/components/Form/CurrencyInput";


function formatter( item: Lookup ) {
	return LocaleUtil.getLocalValue( item );
}

function toId( item: Lookup ) {
	return item.Id;
}

const minBudget = window.glSettings?.minBudget ?? 10000;
const maxBudget = window.glSettings?.maxBudget ?? 1000000;

export function getMaxBudget() {
	return maxBudget;
}

const deltaBudget = 10000;
const budgets: number[] = [];
let x = minBudget;
while ( x <= maxBudget ) {
	budgets.push( x );
	x = x + deltaBudget;
}

function budgetFormatter( item: number ) {
	return CurrencyUtil.toFormattedCurrency( item, 0 );
}

function budgetIFormatter( item: number ) {
	return CurrencyUtil.toFormattedCurrency( item, 0 ) + " " + Strings.aed;
}

interface Props extends IGreenListFormProps {
	service: SubscriptionService;
}

interface State extends IGreenListFormState {
	isLoading: boolean;
	areas?: Lookup[];
	selectedPTypes: Lookup[];
	selectedAreas: Lookup[];
	BudgetMin?: number;
	BudgetMax?: number;
}

const BProps: Partial<BDProps> = {
	wrapperClass: "col-md-12",
	dropButtonClass: "btn btn-default"
};

export class SubscriptionDetailsForm extends Component<Props, State> implements IGreenListForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		const svc = props.service;
		this.state = {
			isLoading: true,
			selectedPTypes: svc.PropertyTypes?.map( pt => PropertyTypesItems.find( x => x.Id === pt.PropertyTypeId )! ) ?? [],
			selectedAreas: [],
			isValid: false,
			BudgetMin: svc.FromValue,
			BudgetMax: svc.ToValue,
		};
	}

	componentDidMount() {
		const svc = this.props.service;
		getGreenListAres().then( r => {
			this.setState( {
				isLoading: false,
				areas: r,
				selectedAreas: svc.Areas?.map( a => r.find( x => x.Id === a.AreaId )! ) ?? [],
			} );
		} );
	}

	isValid = ( _isUserAction: boolean ) => {
		const { selectedAreas, selectedPTypes, BudgetMin, BudgetMax } = this.state;
		const { service } = this.props;
		let isValid = true;
		isValid = isValid && selectedAreas.length > 0;
		isValid = isValid && selectedPTypes.length > 0;
		if ( service.ServiceTypeId !== SubscriptionServiceId.SELL ) {
			isValid = isValid && BudgetMin != null;
			isValid = isValid && BudgetMax != null;
			isValid = isValid && Number( BudgetMax! ) >= Number( BudgetMin! );
		}
		return isValid;
	};

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		const oldData = this.getData( prevState );
		const newData = this.getData( this.state );
		handleDataUpdate( oldData, newData, prevState, this );
	}

	getData = ( state: State = this.state ) => {
		return {
			propertyTypes: state?.selectedPTypes.map( x => x.Id ) || [],
			areas: state?.selectedAreas.map( x => x.Id ) || [],
			budget: { min: state.BudgetMin, max: state.BudgetMax, },
		};
	};

	render() {
		const { selectedAreas, selectedPTypes, BudgetMin, BudgetMax, areas, isLoading } = this.state;
		const { service } = this.props;
		if ( isLoading ) return <>
			<SpinnerLoader/>
		</>;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
			errorManager: defaultErrorManager,
		};
		return (
			<div className="green-list-service-selection">
				<h5 className="greenlist-title">
					<span>{ getServiceName( service ) }</span>
					<small>{ Strings.gl_sub_service_info }</small>
				</h5>
				<div className="row green-list-form greenlist-filter">
					<MultiChoiceDropDown
						showChips={ true }
						baseProps={ BProps }
						items={ PropertyTypesItems } title={ Strings.property_type } id={ "greenListPropertyType" }
						formatter={ formatter } toId={ toId } values={ selectedPTypes }
						onChange={ this.onPropertyTypeChange }/>
					<MultiChoiceDropDown
						showChips={ true }
						baseProps={ BProps }
						showAllOption={ true }
						items={ areas } title={ Strings.area } id={ "greenlistArea" }
						onChange={ this.onAreasChange }
						formatter={ formatter } toId={ toId } values={ selectedAreas }/>
					{
						service.ServiceTypeId !== SubscriptionServiceId.SELL &&
						<>
							<div className="col-md-12 form-group">
								<CurrencyInput
									id={ "BudgetMin" }
									holder={ this }
									required={ true }
									label={ Strings.gl_min_aed }
									currencyType={ Strings.aed }
									containerClassName={ "input-group input-group-custom" }/>
							</div>
							<div className="col-md-12 form-group">
								<CurrencyInput
									id={ "BudgetMax" }
									holder={ this }
									required={ true }
									label={ Strings.gl_max_aed }
									currencyType={ Strings.aed }
									containerClassName={ "input-group input-group-custom" }/>
							</div>
						</>
					}
				</div>
			</div>
		);
	}

	onPropertyTypeChange = ( pTypes: Lookup[] ) => {
		this.updateFilter( { selectedPTypes: pTypes } );
	};
	onAreasChange = ( areas: Lookup[] ) => {
		this.updateFilter( { selectedAreas: areas } );
	};
	onBudgetChange = ( x1?: number, x2?: number ) => {
		this.updateFilter( {
			BudgetMin: x1,
			BudgetMax: x2,
		} );
	};
	updateFilter = ( su?: Partial<State> ) => {
		let state = {
			...su,
		} as State;
		this.setState( state, () => {
			// dispatch(Actions.OWNERS_GREEN_FILTER_UPDATED, filter);
		} );
	};

}
